<template>
  <v-autocomplete
    ref="auto"
    v-model="filter.municipioGrupoSolucao"
    item-text="nome"
    item-value="municipioGrupoSolucaoId"
    :items="groupSolutionList"
    :label="`${isAT ? 'Grupos de Iniciativas' : 'Grupos de Solução'}`"
    :placeholder="`${isAT ? 'Grupos de Iniciativas' : 'Grupos de Solução'}`"
    clearable
    :return-object="true"
    :loading="loading"
    @click="loadGroupSolution"
    @change="change"
    @click:append="clickOnArrow"
  >
    <template slot="no-data">
      <div class="progress" v-if="loading">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>

      <div v-else>
        Nenhuma
        {{ isAT ? "Grupo de Iniciativa" : "Grupo de Solução" }} retornado
      </div>
    </template>
  </v-autocomplete>
</template>

<script>
import { cityGroupSolutionAPI } from "@/modules/city/API/CityGroupSolutionAPI";
import { mapGetters } from "vuex";
import { compare } from "@/helpers/orderByAsc";

export default {
  name: "AppGroupSolutionByCityCombobox",
  props: ["filter", "reload", "onlyEnable", "loadfirst"],
  computed: {
    ...mapGetters(["isAT"]),
  },
  data() {
    return {
      groupSolutionList: [],
      onlyEnableGroupSolutionList: [],
      loading: false,
    };
  },
  mounted() {
    if (this.loadfirst) {
      this.loadGroupSolution();
    }
  },
  methods: {
    clickOnArrow() {
      if (this.$refs.auto.isMenuActive == false)
        this.$refs.auto.$refs.input.click();
      else this.$refs.auto.isMenuActive = false;
    },
    limpar() {
      this.groupSolutionList = [];
      this.onlyEnableGroupSolutionList = [];
    },
    change(value) {
      if (value)
        this.filter.municipioGrupoSolucao = {
          ...value,
        };
      else this.filter.municipioGrupoSolucao = {};

      this.$emit("changeSolution");
    },
    loadGroupSolution() {
      this.loading = true;
      this.limpar();

      cityGroupSolutionAPI
        .comboListByCity(this.$route.params.id)
        .then((resp) => {
          this.groupSolutionList = resp.data.sort((a, b) =>
            compare(a, b, "nome")
          );
          this.loading = false;
        })
        .catch((e) => {
          this.loading = false;
        });
    },
  },
};
</script>
<style scoped>
.progress {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
